package com.eladfinish.bible.contest

import dev.icerock.moko.resources.AssetResource
import kotlin.collections.List

internal object CommonMainAssets9 {
  internal val _27_tehilim_116_txt: AssetResource by lazy { init__27_tehilim_116_txt() }

  internal val _27_tehilim_117_txt: AssetResource by lazy { init__27_tehilim_117_txt() }

  internal val _27_tehilim_118_txt: AssetResource by lazy { init__27_tehilim_118_txt() }

  internal val _27_tehilim_119_txt: AssetResource by lazy { init__27_tehilim_119_txt() }

  internal val _27_tehilim_120_txt: AssetResource by lazy { init__27_tehilim_120_txt() }

  internal val _27_tehilim_121_txt: AssetResource by lazy { init__27_tehilim_121_txt() }

  internal val _27_tehilim_122_txt: AssetResource by lazy { init__27_tehilim_122_txt() }

  internal val _27_tehilim_123_txt: AssetResource by lazy { init__27_tehilim_123_txt() }

  internal val _27_tehilim_124_txt: AssetResource by lazy { init__27_tehilim_124_txt() }

  internal val _27_tehilim_125_txt: AssetResource by lazy { init__27_tehilim_125_txt() }

  internal val _27_tehilim_126_txt: AssetResource by lazy { init__27_tehilim_126_txt() }

  internal val _27_tehilim_127_txt: AssetResource by lazy { init__27_tehilim_127_txt() }

  internal val _27_tehilim_128_txt: AssetResource by lazy { init__27_tehilim_128_txt() }

  internal val _27_tehilim_129_txt: AssetResource by lazy { init__27_tehilim_129_txt() }

  internal val _27_tehilim_130_txt: AssetResource by lazy { init__27_tehilim_130_txt() }

  internal val _27_tehilim_131_txt: AssetResource by lazy { init__27_tehilim_131_txt() }

  internal val _27_tehilim_132_txt: AssetResource by lazy { init__27_tehilim_132_txt() }

  internal val _27_tehilim_133_txt: AssetResource by lazy { init__27_tehilim_133_txt() }

  internal val _27_tehilim_134_txt: AssetResource by lazy { init__27_tehilim_134_txt() }

  internal val _27_tehilim_135_txt: AssetResource by lazy { init__27_tehilim_135_txt() }

  internal val _27_tehilim_136_txt: AssetResource by lazy { init__27_tehilim_136_txt() }

  internal val _27_tehilim_137_txt: AssetResource by lazy { init__27_tehilim_137_txt() }

  internal val _27_tehilim_138_txt: AssetResource by lazy { init__27_tehilim_138_txt() }

  internal val _27_tehilim_139_txt: AssetResource by lazy { init__27_tehilim_139_txt() }

  internal val _27_tehilim_140_txt: AssetResource by lazy { init__27_tehilim_140_txt() }

  internal val _27_tehilim_141_txt: AssetResource by lazy { init__27_tehilim_141_txt() }

  internal val _27_tehilim_142_txt: AssetResource by lazy { init__27_tehilim_142_txt() }

  internal val _27_tehilim_143_txt: AssetResource by lazy { init__27_tehilim_143_txt() }

  internal val _27_tehilim_144_txt: AssetResource by lazy { init__27_tehilim_144_txt() }

  internal val _27_tehilim_145_txt: AssetResource by lazy { init__27_tehilim_145_txt() }

  internal val _27_tehilim_146_txt: AssetResource by lazy { init__27_tehilim_146_txt() }

  internal val _27_tehilim_147_txt: AssetResource by lazy { init__27_tehilim_147_txt() }

  internal val _27_tehilim_148_txt: AssetResource by lazy { init__27_tehilim_148_txt() }

  internal val _27_tehilim_149_txt: AssetResource by lazy { init__27_tehilim_149_txt() }

  internal val _27_tehilim_150_txt: AssetResource by lazy { init__27_tehilim_150_txt() }

  internal val _28_mishley_01_txt: AssetResource by lazy { init__28_mishley_01_txt() }

  internal val _28_mishley_02_txt: AssetResource by lazy { init__28_mishley_02_txt() }

  internal val _28_mishley_03_txt: AssetResource by lazy { init__28_mishley_03_txt() }

  internal val _28_mishley_04_txt: AssetResource by lazy { init__28_mishley_04_txt() }

  internal val _28_mishley_05_txt: AssetResource by lazy { init__28_mishley_05_txt() }

  internal val _28_mishley_06_txt: AssetResource by lazy { init__28_mishley_06_txt() }

  internal val _28_mishley_07_txt: AssetResource by lazy { init__28_mishley_07_txt() }

  internal val _28_mishley_08_txt: AssetResource by lazy { init__28_mishley_08_txt() }

  internal val _28_mishley_09_txt: AssetResource by lazy { init__28_mishley_09_txt() }

  internal val _28_mishley_10_txt: AssetResource by lazy { init__28_mishley_10_txt() }

  internal val _28_mishley_11_txt: AssetResource by lazy { init__28_mishley_11_txt() }

  internal val _28_mishley_12_txt: AssetResource by lazy { init__28_mishley_12_txt() }

  internal val _28_mishley_13_txt: AssetResource by lazy { init__28_mishley_13_txt() }

  internal val _28_mishley_14_txt: AssetResource by lazy { init__28_mishley_14_txt() }

  internal val _28_mishley_15_txt: AssetResource by lazy { init__28_mishley_15_txt() }

  internal fun values(): List<AssetResource> = listOf(_27_tehilim_116_txt, _27_tehilim_117_txt,
      _27_tehilim_118_txt, _27_tehilim_119_txt, _27_tehilim_120_txt, _27_tehilim_121_txt,
      _27_tehilim_122_txt, _27_tehilim_123_txt, _27_tehilim_124_txt, _27_tehilim_125_txt,
      _27_tehilim_126_txt, _27_tehilim_127_txt, _27_tehilim_128_txt, _27_tehilim_129_txt,
      _27_tehilim_130_txt, _27_tehilim_131_txt, _27_tehilim_132_txt, _27_tehilim_133_txt,
      _27_tehilim_134_txt, _27_tehilim_135_txt, _27_tehilim_136_txt, _27_tehilim_137_txt,
      _27_tehilim_138_txt, _27_tehilim_139_txt, _27_tehilim_140_txt, _27_tehilim_141_txt,
      _27_tehilim_142_txt, _27_tehilim_143_txt, _27_tehilim_144_txt, _27_tehilim_145_txt,
      _27_tehilim_146_txt, _27_tehilim_147_txt, _27_tehilim_148_txt, _27_tehilim_149_txt,
      _27_tehilim_150_txt, _28_mishley_01_txt, _28_mishley_02_txt, _28_mishley_03_txt,
      _28_mishley_04_txt, _28_mishley_05_txt, _28_mishley_06_txt, _28_mishley_07_txt,
      _28_mishley_08_txt, _28_mishley_09_txt, _28_mishley_10_txt, _28_mishley_11_txt,
      _28_mishley_12_txt, _28_mishley_13_txt, _28_mishley_14_txt, _28_mishley_15_txt)
}

private fun init__27_tehilim_116_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-116.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-116.txt")

private fun init__27_tehilim_117_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-117.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-117.txt")

private fun init__27_tehilim_118_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-118.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-118.txt")

private fun init__27_tehilim_119_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-119.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-119.txt")

private fun init__27_tehilim_120_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-120.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-120.txt")

private fun init__27_tehilim_121_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-121.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-121.txt")

private fun init__27_tehilim_122_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-122.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-122.txt")

private fun init__27_tehilim_123_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-123.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-123.txt")

private fun init__27_tehilim_124_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-124.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-124.txt")

private fun init__27_tehilim_125_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-125.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-125.txt")

private fun init__27_tehilim_126_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-126.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-126.txt")

private fun init__27_tehilim_127_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-127.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-127.txt")

private fun init__27_tehilim_128_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-128.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-128.txt")

private fun init__27_tehilim_129_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-129.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-129.txt")

private fun init__27_tehilim_130_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-130.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-130.txt")

private fun init__27_tehilim_131_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-131.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-131.txt")

private fun init__27_tehilim_132_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-132.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-132.txt")

private fun init__27_tehilim_133_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-133.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-133.txt")

private fun init__27_tehilim_134_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-134.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-134.txt")

private fun init__27_tehilim_135_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-135.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-135.txt")

private fun init__27_tehilim_136_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-136.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-136.txt")

private fun init__27_tehilim_137_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-137.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-137.txt")

private fun init__27_tehilim_138_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-138.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-138.txt")

private fun init__27_tehilim_139_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-139.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-139.txt")

private fun init__27_tehilim_140_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-140.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-140.txt")

private fun init__27_tehilim_141_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-141.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-141.txt")

private fun init__27_tehilim_142_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-142.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-142.txt")

private fun init__27_tehilim_143_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-143.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-143.txt")

private fun init__27_tehilim_144_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-144.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-144.txt")

private fun init__27_tehilim_145_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-145.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-145.txt")

private fun init__27_tehilim_146_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-146.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-146.txt")

private fun init__27_tehilim_147_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-147.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-147.txt")

private fun init__27_tehilim_148_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-148.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-148.txt")

private fun init__27_tehilim_149_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-149.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-149.txt")

private fun init__27_tehilim_150_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-150.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-150.txt")

private fun init__28_mishley_01_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_28_mishley-01.txt\")") as String, rawPath =
    "allChapters/_28_mishley-01.txt")

private fun init__28_mishley_02_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_28_mishley-02.txt\")") as String, rawPath =
    "allChapters/_28_mishley-02.txt")

private fun init__28_mishley_03_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_28_mishley-03.txt\")") as String, rawPath =
    "allChapters/_28_mishley-03.txt")

private fun init__28_mishley_04_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_28_mishley-04.txt\")") as String, rawPath =
    "allChapters/_28_mishley-04.txt")

private fun init__28_mishley_05_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_28_mishley-05.txt\")") as String, rawPath =
    "allChapters/_28_mishley-05.txt")

private fun init__28_mishley_06_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_28_mishley-06.txt\")") as String, rawPath =
    "allChapters/_28_mishley-06.txt")

private fun init__28_mishley_07_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_28_mishley-07.txt\")") as String, rawPath =
    "allChapters/_28_mishley-07.txt")

private fun init__28_mishley_08_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_28_mishley-08.txt\")") as String, rawPath =
    "allChapters/_28_mishley-08.txt")

private fun init__28_mishley_09_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_28_mishley-09.txt\")") as String, rawPath =
    "allChapters/_28_mishley-09.txt")

private fun init__28_mishley_10_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_28_mishley-10.txt\")") as String, rawPath =
    "allChapters/_28_mishley-10.txt")

private fun init__28_mishley_11_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_28_mishley-11.txt\")") as String, rawPath =
    "allChapters/_28_mishley-11.txt")

private fun init__28_mishley_12_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_28_mishley-12.txt\")") as String, rawPath =
    "allChapters/_28_mishley-12.txt")

private fun init__28_mishley_13_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_28_mishley-13.txt\")") as String, rawPath =
    "allChapters/_28_mishley-13.txt")

private fun init__28_mishley_14_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_28_mishley-14.txt\")") as String, rawPath =
    "allChapters/_28_mishley-14.txt")

private fun init__28_mishley_15_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_28_mishley-15.txt\")") as String, rawPath =
    "allChapters/_28_mishley-15.txt")

public actual val SharedRes.assets.allChapters._27_tehilim_116_txt: AssetResource
  get() = CommonMainAssets9._27_tehilim_116_txt

public actual val SharedRes.assets.allChapters._27_tehilim_117_txt: AssetResource
  get() = CommonMainAssets9._27_tehilim_117_txt

public actual val SharedRes.assets.allChapters._27_tehilim_118_txt: AssetResource
  get() = CommonMainAssets9._27_tehilim_118_txt

public actual val SharedRes.assets.allChapters._27_tehilim_119_txt: AssetResource
  get() = CommonMainAssets9._27_tehilim_119_txt

public actual val SharedRes.assets.allChapters._27_tehilim_120_txt: AssetResource
  get() = CommonMainAssets9._27_tehilim_120_txt

public actual val SharedRes.assets.allChapters._27_tehilim_121_txt: AssetResource
  get() = CommonMainAssets9._27_tehilim_121_txt

public actual val SharedRes.assets.allChapters._27_tehilim_122_txt: AssetResource
  get() = CommonMainAssets9._27_tehilim_122_txt

public actual val SharedRes.assets.allChapters._27_tehilim_123_txt: AssetResource
  get() = CommonMainAssets9._27_tehilim_123_txt

public actual val SharedRes.assets.allChapters._27_tehilim_124_txt: AssetResource
  get() = CommonMainAssets9._27_tehilim_124_txt

public actual val SharedRes.assets.allChapters._27_tehilim_125_txt: AssetResource
  get() = CommonMainAssets9._27_tehilim_125_txt

public actual val SharedRes.assets.allChapters._27_tehilim_126_txt: AssetResource
  get() = CommonMainAssets9._27_tehilim_126_txt

public actual val SharedRes.assets.allChapters._27_tehilim_127_txt: AssetResource
  get() = CommonMainAssets9._27_tehilim_127_txt

public actual val SharedRes.assets.allChapters._27_tehilim_128_txt: AssetResource
  get() = CommonMainAssets9._27_tehilim_128_txt

public actual val SharedRes.assets.allChapters._27_tehilim_129_txt: AssetResource
  get() = CommonMainAssets9._27_tehilim_129_txt

public actual val SharedRes.assets.allChapters._27_tehilim_130_txt: AssetResource
  get() = CommonMainAssets9._27_tehilim_130_txt

public actual val SharedRes.assets.allChapters._27_tehilim_131_txt: AssetResource
  get() = CommonMainAssets9._27_tehilim_131_txt

public actual val SharedRes.assets.allChapters._27_tehilim_132_txt: AssetResource
  get() = CommonMainAssets9._27_tehilim_132_txt

public actual val SharedRes.assets.allChapters._27_tehilim_133_txt: AssetResource
  get() = CommonMainAssets9._27_tehilim_133_txt

public actual val SharedRes.assets.allChapters._27_tehilim_134_txt: AssetResource
  get() = CommonMainAssets9._27_tehilim_134_txt

public actual val SharedRes.assets.allChapters._27_tehilim_135_txt: AssetResource
  get() = CommonMainAssets9._27_tehilim_135_txt

public actual val SharedRes.assets.allChapters._27_tehilim_136_txt: AssetResource
  get() = CommonMainAssets9._27_tehilim_136_txt

public actual val SharedRes.assets.allChapters._27_tehilim_137_txt: AssetResource
  get() = CommonMainAssets9._27_tehilim_137_txt

public actual val SharedRes.assets.allChapters._27_tehilim_138_txt: AssetResource
  get() = CommonMainAssets9._27_tehilim_138_txt

public actual val SharedRes.assets.allChapters._27_tehilim_139_txt: AssetResource
  get() = CommonMainAssets9._27_tehilim_139_txt

public actual val SharedRes.assets.allChapters._27_tehilim_140_txt: AssetResource
  get() = CommonMainAssets9._27_tehilim_140_txt

public actual val SharedRes.assets.allChapters._27_tehilim_141_txt: AssetResource
  get() = CommonMainAssets9._27_tehilim_141_txt

public actual val SharedRes.assets.allChapters._27_tehilim_142_txt: AssetResource
  get() = CommonMainAssets9._27_tehilim_142_txt

public actual val SharedRes.assets.allChapters._27_tehilim_143_txt: AssetResource
  get() = CommonMainAssets9._27_tehilim_143_txt

public actual val SharedRes.assets.allChapters._27_tehilim_144_txt: AssetResource
  get() = CommonMainAssets9._27_tehilim_144_txt

public actual val SharedRes.assets.allChapters._27_tehilim_145_txt: AssetResource
  get() = CommonMainAssets9._27_tehilim_145_txt

public actual val SharedRes.assets.allChapters._27_tehilim_146_txt: AssetResource
  get() = CommonMainAssets9._27_tehilim_146_txt

public actual val SharedRes.assets.allChapters._27_tehilim_147_txt: AssetResource
  get() = CommonMainAssets9._27_tehilim_147_txt

public actual val SharedRes.assets.allChapters._27_tehilim_148_txt: AssetResource
  get() = CommonMainAssets9._27_tehilim_148_txt

public actual val SharedRes.assets.allChapters._27_tehilim_149_txt: AssetResource
  get() = CommonMainAssets9._27_tehilim_149_txt

public actual val SharedRes.assets.allChapters._27_tehilim_150_txt: AssetResource
  get() = CommonMainAssets9._27_tehilim_150_txt

public actual val SharedRes.assets.allChapters._28_mishley_01_txt: AssetResource
  get() = CommonMainAssets9._28_mishley_01_txt

public actual val SharedRes.assets.allChapters._28_mishley_02_txt: AssetResource
  get() = CommonMainAssets9._28_mishley_02_txt

public actual val SharedRes.assets.allChapters._28_mishley_03_txt: AssetResource
  get() = CommonMainAssets9._28_mishley_03_txt

public actual val SharedRes.assets.allChapters._28_mishley_04_txt: AssetResource
  get() = CommonMainAssets9._28_mishley_04_txt

public actual val SharedRes.assets.allChapters._28_mishley_05_txt: AssetResource
  get() = CommonMainAssets9._28_mishley_05_txt

public actual val SharedRes.assets.allChapters._28_mishley_06_txt: AssetResource
  get() = CommonMainAssets9._28_mishley_06_txt

public actual val SharedRes.assets.allChapters._28_mishley_07_txt: AssetResource
  get() = CommonMainAssets9._28_mishley_07_txt

public actual val SharedRes.assets.allChapters._28_mishley_08_txt: AssetResource
  get() = CommonMainAssets9._28_mishley_08_txt

public actual val SharedRes.assets.allChapters._28_mishley_09_txt: AssetResource
  get() = CommonMainAssets9._28_mishley_09_txt

public actual val SharedRes.assets.allChapters._28_mishley_10_txt: AssetResource
  get() = CommonMainAssets9._28_mishley_10_txt

public actual val SharedRes.assets.allChapters._28_mishley_11_txt: AssetResource
  get() = CommonMainAssets9._28_mishley_11_txt

public actual val SharedRes.assets.allChapters._28_mishley_12_txt: AssetResource
  get() = CommonMainAssets9._28_mishley_12_txt

public actual val SharedRes.assets.allChapters._28_mishley_13_txt: AssetResource
  get() = CommonMainAssets9._28_mishley_13_txt

public actual val SharedRes.assets.allChapters._28_mishley_14_txt: AssetResource
  get() = CommonMainAssets9._28_mishley_14_txt

public actual val SharedRes.assets.allChapters._28_mishley_15_txt: AssetResource
  get() = CommonMainAssets9._28_mishley_15_txt
